import { MIXED_SIZES } from '../../pages/PhotoStyler/TileDesignerConsts'
import type { TFunction } from 'i18next'
import { getSizesData } from '@mixtiles/web-backend-shared'

// This file includes SSR runnable code

export function isImperialUnitsCountry(pricingCountry: string): boolean {
  if (!pricingCountry) return false
  return ['us', 'ca'].includes(pricingCountry.toLowerCase())
}

export function getSizeName({
  size,
  t,
  pricingCountry,
}: {
  size: string
  t: TFunction
  pricingCountry: string
}) {
  if (size === MIXED_SIZES) {
    return t('order.styles.mixed_styles')
  } else {
    const isSizesInInches = isImperialUnitsCountry(pricingCountry)
    if (isSizesInInches) {
      return getSizesData()[size]?.longDisplayName
    }
    return getSizesData()[size]?.longDisplayNameCms
  }
}
